module.exports = __webpack_public_path__ + "static/media/helix.917190f2.svg";